import React from 'react';
import { EMP_DETAILS_TYPE } from '../../../utils/Constant';
import EmployeeDetails from './EmployeeDetails';
import { EMPLOYEE_INFORMATION_HELPER } from '../AdminSettingsHelper';

const EmployeeInformationPage: React.FunctionComponent = () => {
  return (
    <EmployeeDetails
      detailType={EMP_DETAILS_TYPE.INFO}
      columnsHeder={EMPLOYEE_INFORMATION_HELPER}
      title="Employee Information"
    />
  );
};
export default EmployeeInformationPage;
